import { FC } from 'react';
import IcoCloseRound from '@/assets/svg/ico_close_round.svg?react';
import IcoInfoRound from '@/assets/svg/ico_info_round.svg?react';
import styles from '@/components/blocks/InfoNotice/InfoNotice.module.scss';
import { InfoNoticePropsIF } from '@/components/blocks/InfoNotice/InfoNotice.types';
import Button from '@/components/controls/Button/Button.component';

const InfoNotice: FC<InfoNoticePropsIF> = ({
    children,
    className = '',
    onClose,
    closeDataTest = 'close_info_notice_button',
}) => (
    <div className={`flc ${styles.notice} ${className}`} role="status">
        <IcoInfoRound className={styles.icon} />
        <div>{children}</div>
        {onClose && (
            <Button
                isCustom
                type="button"
                dataTest={closeDataTest}
                className="flc"
                aria-label="Закрыть"
                clickHandler={onClose}
            >
                <IcoCloseRound className={styles.icon} />
            </Button>
        )}
    </div>
);

export default InfoNotice;
